"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _tinymceReact = require("@tinymce/tinymce-react");

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tinyMCE = _config2.default.tinyMCE;


var InlineEditableDiv = function InlineEditableDiv(props) {
  var isEditMode = props.isEditMode,
      className = props.className,
      keyProperty = props.keyProperty,
      property = props.property,
      updateProps = props.updateProps,
      value = props.value,
      setData = props.setData;


  var handleEditorChange = function handleEditorChange(content, editor) {
    updateProps(property, keyProperty, content, setData);
  };

  return _react2.default.createElement(
    "div",
    { className: "editable-div position-relative " + className },
    isEditMode && _react2.default.createElement(_tinymceReact.Editor, {
      initialValue: value || "",
      inline: true
      // fontsize_formats="8pt,10pt,12pt,14pt,16pt,18pt,20pt,22pt,24pt,26pt,28pt,30pt,32pt,34pt,36pt"
      , apiKey: tinyMCE,
      init: {
        color_map: ["000000", "Black", "808080", "Gray", "FFFFFF", "White", "FF0000", "Red", "FFFF00", "Yellow", "008000", "Green", "0000FF", "Blue"],
        fontsize_formats: "10pt 12pt 13pt 14pt 15pt 16pt 17pt 18pt 19pt 20pt 22pt 24pt 26pt 28pt 30pt 32pt 34pt 36pt 38pt 40pt 44pt 48pt",
        menubar: false,
        plugins: ["advlist autolink lists link image charmap print preview anchor", "searchreplace visualblocks code fullscreen", "insertdatetime media table paste code help wordcount"],
        toolbar: " formatselect | fontselect | fontsizeselect | forecolor | alignleft aligncenter alignright alignjustify | bullist numlist  "
      },
      onEditorChange: handleEditorChange
    }),
    !isEditMode && value
  );
};

exports.default = InlineEditableDiv;